import ScoreCardHeader from "../Views/ScoreCardHeader";
import "./ScoreCardQuestionScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import emptyStar from "../../../assets/images/score-card/score-card-empty-star.svg";
import filledStar from "../../../assets/images/score-card/score-card-filled-star.svg";
import nextIcon from "../../../assets/images/score-card-next-icon.svg";
import nextDisabledIcon from "../../../assets/images/score-card-next-disabled-icon.svg";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import { getFirstAndRemainingWords } from "utils/utils";

const ScoreCardQuestionScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const scoreCardData = location.state?.scoreCardData;
  const currentTypeIndex = location.state?.currentTypeIndex ?? 0;
  const allAnswers = location.state?.allAnswers ?? {};
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState<Record<string, any>>(
    {},
  );
  const currentQuestion = useMemo(() => {
    return scoreCardData?.questions?.[currentQuestionIndex];
  }, [scoreCardData, currentQuestionIndex]);

  const selectedAnswerId = currentQuestion
    ? (selectedAnswers[currentQuestion.id]?.id ?? null)
    : null;
  const isNextDisabled =
    !currentQuestion ||
    !selectedAnswers[currentQuestion.id] ||
    selectedAnswerId === null;

  const headerTitle = getFirstAndRemainingWords(scoreCardData?.header_title);
  const headerSubTitle = getFirstAndRemainingWords(
    scoreCardData?.header_sub_title,
  );

  // Score card types where the FIRST word is orange (not the last)
  const ORANGE_FIRST_TYPES = [
    "WORK_STYLE",
    "LEADERSHIP_TEAM",
    "SCALING_READINESS",
  ];
  const isOrangeFirst = ORANGE_FIRST_TYPES.includes(
    scoreCardData?.score_card_type,
  );

  // For orangeFirst: subTitle=firstWord(orange), title=remainingWords(white)
  // For default:     title=firstWord(white), subTitle=remainingWords(orange)
  const headerOrange = isOrangeFirst
    ? (headerTitle?.firstWord ?? "")
    : (headerTitle?.remainingWords ?? "");
  const headerWhite = isOrangeFirst
    ? (headerTitle?.remainingWords ?? "")
    : (headerTitle?.firstWord ?? "");

  const handleOptionSelect = (answer: any) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [currentQuestion.id]: answer,
    }));
  };

  const handleNext = () => {
    if (!currentQuestion) return;

    const selectedAnswer = selectedAnswers[currentQuestion.id];
    if (!selectedAnswer) return;

    const isLastQuestion =
      currentQuestionIndex === scoreCardData.questions.length - 1;

    if (!isLastQuestion) {
      setCurrentQuestionIndex((prev) => prev + 1);
      return;
    }

    const updatedAllAnswers = {
      ...allAnswers,
      [scoreCardData.score_card_type]: selectedAnswers,
    };

    navigate(ROUTE_PATHS.WSM_SCORE_CARD_MATTERS_SCREEN, {
      state: {
        currentTypeIndex: currentTypeIndex + 1,
        allAnswers: updatedAllAnswers,
      },
      replace: true,
    });
  };

  // const handleBack = () => {
  //   if (currentQuestionIndex === 0) {
  //     navigate(-1);
  //     return;
  //   }

  //   setCurrentQuestionIndex((prev: number) => prev - 1);
  // };

  const handleBack = () => {
    if (currentQuestionIndex === 0) {
      // Navigate to the previous score card type screen
      if (currentTypeIndex > 0) {
        navigate(ROUTE_PATHS.WSM_SCORE_CARD_MATTERS_SCREEN, {
          state: {
            currentTypeIndex: currentTypeIndex - 1,
            allAnswers,
          },
          replace: true,
        });
      } else {
        // If this is the very first type, go back further
        navigate(-1);
      }
      return;
    }

    setCurrentQuestionIndex((prev: number) => prev - 1);
  };

  if (!scoreCardData || !currentQuestion) return null;

  return (
    <div className="wms-mobile-container">
      <div className="score-card-question-screen-container">
        <div className="score-card-question-screen-header-sticky">
          <ScoreCardHeader
            title={headerWhite}
            subTitle={headerOrange}
            orangeFirst={isOrangeFirst}
          />
        </div>
        <div className="score-card-question-screen-content-container">
          <div className="screen-title-container">
            <img src={backIcon} alt="dropdown-logo" onClick={handleBack} />
            <span>
              {headerSubTitle?.firstWord}{" "}
              <span style={{ color: "#FF6B35" }}>
                {headerSubTitle?.remainingWords}
              </span>
            </span>
            <div className="left-container"></div>
          </div>
          <div className="question-container">
            <span>{currentQuestionIndex + 1}.</span>
            <span>{currentQuestion.question}</span>
          </div>
          <div className="options-container">
            {currentQuestion.answers.map((answer: any) => (
              <div
                key={answer.id}
                className={`option-card ${selectedAnswerId === answer.id ? "selected" : ""}`}
                onClick={() => handleOptionSelect(answer)}
              >
                <img
                  src={selectedAnswerId === answer.id ? filledStar : emptyStar}
                  alt="selection-icon"
                />
                {answer.title}
              </div>
            ))}
          </div>
          <div
            className={`button-container ${isNextDisabled ? "disabled" : ""}`}
            onClick={isNextDisabled ? undefined : handleNext}
          >
            <span>Next</span>
            <img
              src={isNextDisabled ? nextDisabledIcon : nextIcon}
              alt="right-arrow-icon"
              className="button-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreCardQuestionScreen;
